import { Link } from "react-router-dom";

export interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="flex items-center flex-wrap gap-2 text-xs text-foreground-500">
      {items.map((item, index) => (
        <span key={index} className="flex items-center gap-2">
          {item.to ? (
            <Link to={item.to} className="hover:text-primary-600 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-foreground-800">{item.label}</span>
          )}
          {index < items.length - 1 && (
            <i className="ri-arrow-right-s-line text-foreground-300"></i>
          )}
        </span>
      ))}
    </nav>
  );
}